/**
 * Shared icon + colour mapping for template rows and the template modal.
 * The backend stores a lucide icon name and a colour key on each template; the
 * UI resolves them here so the list, modal, and any future surface agree.
 */

import type { ComponentType } from 'react';
import { FileText, Target, Boxes, GitPullRequest, ClipboardCheck, Sparkles } from 'lucide-react';

type IconComponent = ComponentType<{ className?: string }>;

const TEMPLATE_ICON: Record<string, IconComponent> = {
  FileText,
  Target,
  Boxes,
  GitPullRequest,
  ClipboardCheck,
  Sparkles,
};

export function templateIcon(name?: string): IconComponent {
  return (name && TEMPLATE_ICON[name]) || FileText;
}

interface ColorClasses {
  bg: string;
  fg: string;
}

const TEMPLATE_COLOR: Record<string, ColorClasses> = {
  amber: { bg: 'bg-amber-100 dark:bg-amber-900/30', fg: 'text-amber-600 dark:text-amber-400' },
  blue: { bg: 'bg-blue-100 dark:bg-blue-900/30', fg: 'text-blue-600 dark:text-blue-400' },
  violet: { bg: 'bg-violet-100 dark:bg-violet-900/30', fg: 'text-violet-600 dark:text-violet-400' },
  emerald: { bg: 'bg-emerald-100 dark:bg-emerald-900/30', fg: 'text-emerald-600 dark:text-emerald-400' },
  sky: { bg: 'bg-sky-100 dark:bg-sky-900/30', fg: 'text-sky-600 dark:text-sky-400' },
  rose: { bg: 'bg-rose-100 dark:bg-rose-900/30', fg: 'text-rose-600 dark:text-rose-400' },
  slate: { bg: 'bg-slate-100 dark:bg-slate-800', fg: 'text-slate-600 dark:text-slate-300' },
};

export function templateColor(key?: string): ColorClasses {
  return TEMPLATE_COLOR[key ?? 'slate'] ?? TEMPLATE_COLOR.slate;
}
